import {
  FiArchive,
  FiCheckCircle,
  FiEdit,
  FiEye,
  FiRefreshCcw,
  FiTrash2,
  FiUserCheck,
  FiUserX,
  FiXCircle,
} from "react-icons/fi"

import Button from "../../../component/button/button"
import { TQuestion } from "../../../api/type"
import { isUnverifiedQuestion } from "../utils/questionMeta"

type QuestionDetailActionsProps = {
  question: TQuestion
  isEditing?: boolean
  onMoveToDraft: () => void
  onArchive: () => void
  onActivate: () => void
  onEdit: () => void
  onPreview: () => void
  onPublish: () => void
  onToggleLearnerPublish: () => void
  onVerify: () => void
  onReject: () => void
  onDelete: () => void
}

const QuestionDetailActions = ({
  question,
  isEditing = false,
  onMoveToDraft,
  onArchive,
  onActivate,
  onEdit,
  onPreview,
  onPublish,
  onToggleLearnerPublish,
  onVerify,
  onReject,
  onDelete,
}: QuestionDetailActionsProps) => (
  <div className="question-detail__actions">
    {isEditing ? (
      <Button
        text="Preview"
        type="secondary"
        icon={<FiEye size={18} />}
        onClick={onPreview}
      />
    ) : (
      <Button
        text="Edit"
        type="secondary"
        icon={<FiEdit size={18} />}
        onClick={onEdit}
      />
    )}
    {isUnverifiedQuestion(question) && (
      <>
        <Button
          text="Verify"
          type="secondary"
          icon={<FiCheckCircle size={18} />}
          onClick={onVerify}
        />
        {question.verification_status !== "rejected" && (
          <Button
            text="Reject"
            type="secondary"
            icon={<FiXCircle size={18} />}
            onClick={onReject}
          />
        )}
      </>
    )}
    {question.question_status === "draft" && !isUnverifiedQuestion(question) && (
      <Button
        text="Publish"
        type="secondary"
        icon={<FiCheckCircle size={18} />}
        onClick={onPublish}
      />
    )}
    {question.question_status === "published" && (
      <>
        <Button
          text="Move to draft"
          type="secondary"
          icon={<FiRefreshCcw size={18} />}
          onClick={onMoveToDraft}
        />
        <Button
          text="Archive"
          type="secondary"
          icon={<FiArchive size={18} />}
          onClick={onArchive}
        />
      </>
    )}
    {question.question_status === "archived" && (
      <Button
        text="Unarchive"
        type="secondary"
        icon={<FiCheckCircle size={18} />}
        onClick={onActivate}
      />
    )}
    {!isEditing &&
      question.question_status === "published" &&
      !isUnverifiedQuestion(question) &&
      (question.published_to_learner ? (
        <Button
          text="Remove from learners"
          type="secondary"
          icon={<FiUserX size={18} />}
          onClick={onToggleLearnerPublish}
        />
      ) : (
        <Button
          text="Publish to learners"
          type="secondary"
          icon={<FiUserCheck size={18} />}
          onClick={onToggleLearnerPublish}
        />
      ))}
    <Button
      text="Delete"
      type="secondary"
      icon={<FiTrash2 size={18} />}
      onClick={onDelete}
    />
  </div>
)

export default QuestionDetailActions
